<template>
  <div :class="$style.kfWrap">
    <div :class="$style.kfContent">
      <div :class="$style.kfContentI" @click="router.push('/gamestore')">
        <img :class="$style.kfContentII" :src="yywI31" alt="" />
        <div :class="$style.kfContentIT">我要买</div>
      </div>
      <div :class="$style.kfContentI" @click="$openInNewTab('/profile/account')">
        <img :class="$style.kfContentII" :src="yywI32" alt="" />
        <div :class="$style.kfContentIT">我要卖</div>
      </div>
      <div :class="$style.kfContentI" @click="$openInNewTab('/helpcenter?id=14')">
        <img :class="$style.kfContentII" :src="yywI33" alt="" />
        <div :class="$style.kfContentIT">投诉建议</div>
      </div>
      <div :class="$style.kfContentI" @click="$openInNewTab('/helpcenter?id=11')">
        <img :class="$style.kfContentII" :src="yywI34" alt="" />
        <div :class="$style.kfContentIT">在线客服</div>
      </div>
      <!-- <div :class="$style.kfContentI" @click="scrollToTop">
        <img :class="$style.kfContentII" :src="wbHH38" alt="" />
        <div :class="$style.kfContentIT">回到顶部</div>
      </div> -->
    </div>
  </div>

  <!-- 意见反馈弹窗 -->
  <a-modal
    v-model:open="showFeedbackModal"
    title="意见反馈"
    ok-text="提交"
    cancel-text="取消"
    @ok="submitFeedback"
  >
    <a-textarea
      v-model:value="feedbackContent"
      placeholder="请输入您的意见或建议"
      :rows="4"
    />
  </a-modal>
</template>

<script setup>
import { ref } from "vue";
import axios from "@/axios";
import yywI31 from "@assets/image/yywI31.png";
import yywI32 from "@assets/image/yywI32.png";
import yywI33 from "@assets/image/yywI33.png";
import yywI34 from "@assets/image/yywI34.png";
import { message } from "ant-design-vue";
import { useRouter } from 'vue-router'
const router = useRouter()

const showFeedbackModal = ref(false);
const feedbackContent = ref("");


// 提交意见反馈
const submitFeedback = async () => {
  if (!feedbackContent.value.trim()) {
    message.warning("请输入您的意见或建议");
    return;
  }

  try {
    const res = await axios.post("web/users/userfeed/", {
      remark: feedbackContent.value.trim(),
    });

    if (res?.data?.status === 10000) {
      message.success("感谢您的反馈！");
      showFeedbackModal.value = false;
      feedbackContent.value = "";
    } else {
      message.error("提交失败，请稍后再试");
    }
  } catch (error) {
    message.error("提交失败，请稍后再试");
  }
};

// const scrollToTop = () => {
//   window.scrollTo({
//     top: 0,
//     behavior: "smooth",
//   });
// };
</script>

<style module>
.kfWrap {
  width: 80px;
  position: fixed;
  right: 60px;
  top: 120px;
  z-index: 8;
}
.kfContent {
  width: 80;
  height: 320px;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.kfContentI {
  cursor: pointer;
  flex-shrink: 0;
}
.kfContentII {
  display: block;
  width: 24px;
  height: 24px;
  margin: 0 auto 6px;
}
.kfContentIT {
  color: #666666;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
